import type { IconProps } from './types';

const AlertExclamationIcon = (props: IconProps) => {
  const { color = 'currentColor', size = 24, ref, ...other } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      {...other}
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
    >
      <rect x="10.667" y="4.66675" width="2.66667" height="9.33333" fill={color} />
      <rect x="10.667" y="16.6667" width="2.66667" height="2.66667" fill={color} />
    </svg>
  );
};

export { AlertExclamationIcon };
